import React, { useContext, useState } from 'react'
import { CheckOutContext } from '../../Context/CheckOutContext.jsx';
import { TextField } from '@mui/material';
import { FaRegWindowClose } from 'react-icons/fa';

const CancelOrderModal = ({ visible, onClose, orderId }) => {

    const [reason, setReason] = useState('');
    const { cancelOrder } = useContext(CheckOutContext)

    if (!visible) return null


    const handleCloseModalById = (e) => {
        if (e.target.id === "modal")
            onClose();
    }

    const getReason = (e) => {
        setReason(e.target.value)
    }

    return (
        <div id="modal" onClick={handleCloseModalById} className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-50">
            <div className="bg-white p-2 rounded w-11/12 sm:w-9/12 lg:w-8/12 relative">
                <button onClick={onClose} className='absolute right-2 text-red-600 hover:text-red-500'><FaRegWindowClose size={24} /></button>
                <h1 className="font-semibold text-center text-xl text-gray-700 my-3">Review Product</h1>
                <hr />
                <div className="flex flex-col my-4">
                    <div className="my-2">
                        <TextField onChange={getReason} name="text" className="w-full" id="filled-basic" label="Reason" variant="outlined" />
                    </div>
                    <button onClick={() => cancelOrder(reason, orderId, onClose)} className="bg-red-600 p-3 px-8 rounded text-white hover:bg-red-500 transition">Cancel</button>
                </div>
            </div>
        </div>
    )
}

export default CancelOrderModal